export const tabs = {
  LANGUAGE: {
    id: 'language',
  },
  TRANSLATION: {
    id: 'translation',
  },
}